import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-6 md:gap-10 lg:gap-20 items-center" }
const _hoisted_2 = { class: "text-base md:text-lg lg:text-xl text-center flex flex-col items-center gap-2" }
const _hoisted_3 = { class: "flex flex-wrap gap-4 md:gap-8 lg:gap-16 justify-center w-showcase" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col gap-2 items-center text-center text-base md:text-lg lg:text-xl"
}
const _hoisted_5 = { class: "md:hidden text-lg font-semibold" }

import { useInstruments } from "@/utils/conductor";
import {
  Content,
  ContentCategory,
  contentMainLinks,
  contents,
} from "@/utils/content";
import { PlayableInstrument } from "@/utils/instruments";
import { isHoverable } from "@/utils/utils";
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import ContentItem from "../atoms/ContentItem.vue";
import Button from "../atoms/Button.vue";
import Icon from "../atoms/Icon.vue";
import Link from "../atoms/Link.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    category: null,
    instrument: null
  },
  setup(__props: any) {

const props = __props as {
  category: keyof typeof ContentCategory;
  instrument: keyof typeof PlayableInstrument;
}

const { t } = useI18n();
const hoverable = isHoverable();



const contentList = contents[props.category];
const moreLink = contentMainLinks[props.category];
const displayed = ref<Content | undefined>();
const showDescription = ref(false);

const instruments = useInstruments();

const displayItem = (item: Content) => {
  if (item.key !== displayed.value?.key) {
    displayed.value = item;
    if (showDescription.value) {
      showDescription.value = false;
      setTimeout(() => (showDescription.value = true), 100);
    } else {
      showDescription.value = true;
    }
  }

  // Play note
  if (instruments) {
    if (props.instrument === PlayableInstrument.clarinet)
      instruments.playClarinet();
    if (props.instrument === PlayableInstrument.rhodes)
      instruments.playRhodes();
    if (props.instrument === PlayableInstrument.drum) instruments.playDrums();
    if (props.instrument === PlayableInstrument.synth) instruments.playSynth();
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, _toDisplayString(_unref(t)(`contents.${__props.category}.description`)), 1),
      _createVNode(Link, {
        href: _unref(moreLink),
        target: "_blank"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)(`${__props.category}.more`)), 1)
        ]),
        _: 1
      }, 8, ["href"])
    ]),
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contentList), (item) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.key
        }, [
          _createVNode(ContentItem, {
            title: _unref(t)(`contents.${__props.category}.${item.key}.title`),
            img: item.img,
            url: _unref(hoverable) ? item.link : undefined,
            active: displayed.value ? displayed.value.key === item.key : undefined,
            onMouseenter: ($event: any) => (_unref(hoverable) ? displayItem(item) : 'prevent'),
            onFocus: ($event: any) => (_unref(hoverable) ? displayItem(item) : 'prevent'),
            onClick: ($event: any) => (!_unref(hoverable) ? displayItem(item) : 'prevent')
          }, null, 8, ["title", "img", "url", "active", "onMouseenter", "onFocus", "onClick"])
        ]))
      }), 128))
    ]),
    _createVNode(_Transition, {
      name: "quick-fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (showDescription.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("h2", _hoisted_5, _toDisplayString(_unref(t)(`contents.${__props.category}.${displayed.value?.key}.title`)), 1),
              _createElementVNode("div", null, _toDisplayString(_unref(t)(`contents.${__props.category}.${displayed.value?.key}.description`)), 1),
              _createVNode(Button, {
                class: "touchscreen-only inline-flex",
                href: displayed.value?.link,
                color: "secondary",
                "aria-label": _unref(t)(`${__props.category}.play`)
              }, {
                default: _withCtx(() => [
                  _createVNode(Icon, {
                    name: "arrow",
                    size: "s"
                  })
                ]),
                _: 1
              }, 8, ["href", "aria-label"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})